export default {
  wishListTitle: {
    id: 'buyback_refurbisher_listing_title',
    defaultMessage: 'BuyBack listings',
  },
  marketInputLabel: {
    id: 'buyback_refurbisher_listing_filters_market',
    defaultMessage: 'Market',
  },
  allMarkets: {
    id: 'buyback_refurbisher_listing_filters_all_market',
    defaultMessage: 'All',
  },
  savedProductsCount: {
    id: 'buyback_refurbisher_listing_saved_products_count',
    defaultMessage: '{total} products saved',
  },
  buttonImportExport: {
    id: 'buyback_refurbisher_listing_import_export_cta',
    defaultMessage: 'Import or export CSV file',
  },
  buttonCreate: {
    id: 'buyback_refurbisher_listing_create_cta',
    defaultMessage: 'Create listing',
  },
  toastImportSuccessTitle: {
    id: 'buyback_refurbisher_listing_import_success_title',
    defaultMessage: 'Listings imported. ✔️',
  },
  toastImportSuccessMessage: {
    id: 'buyback_refurbisher_listing_import_success_message',
    defaultMessage:
      'Import n°{taskNumber} has started: check your notifications for updates.',
  },
  toastExportSuccessTitle: {
    id: 'buyback_refurbisher_listing_export_success_title',
    defaultMessage: 'Listings exported. ✔️',
  },
  toastExportSuccessMessage: {
    id: 'buyback_refurbisher_listing_export_success_message',
    defaultMessage:
      'Export n°{taskNumber} has started: check your notifications for updates.',
  },
  gradeFlawless: {
    id: 'buyback_refurbisher_listing_filters_grade_diamond',
    defaultMessage: 'Functional - Flawless',
  },
  gradeGood: {
    id: 'buyback_refurbisher_listing_filters_grade_platimum',
    defaultMessage: 'Functional - Good',
  },
  gradeUsed: {
    id: 'buyback_refurbisher_listing_filters_grade_gold',
    defaultMessage: 'Functional - Used',
  },
  gradeCracked: {
    id: 'buyback_refurbisher_listing_filters_grade_silver',
    defaultMessage: 'Functional - Cracked',
  },
  gradeBrokenScratches: {
    id: 'buyback_refurbisher_listing_filters_grade_bronze',
    defaultMessage: 'Not functional - Broken parts with scratches',
  },
  gradeBrokenCraks: {
    id: 'buyback_refurbisher_listing_filters_grade_stallone',
    defaultMessage: 'Not functional - Broken parts with cracks',
  },
  toastTimeoutTitle: {
    id: 'buyback_quotes_timeout_toast_title',
    defaultMessage: 'Loading... this could take a sec',
  },
  toastTimeoutContent: {
    id: 'buyback_quotes_timeout_toast_content',
    defaultMessage: 'Refresh the page to view prices faster.',
  },
}
